import { consoleWarn } from "vuetify/lib/util/console";

export default {
	name: "CrudableMixin",

	computed: {
		keyedBread() {
			if ( typeof this.crud === "string" ) {
				return {
					b: `browse_${this.crud}`,
					r: `read_${this.crud}`,
					e: `edit_${this.crud}`,
					a: `add_${this.crud}`,
					d: `delete_${this.crud}`
				};
			}

			return this.crud;
		},

		canBrowse() {
			return this.keyedBread.hasOwnProperty( "b" )
				? this.$can( this.keyedBread.b )
				: true;
		},

		canRead() {
			return this.keyedBread.hasOwnProperty( "r" )
				? this.$can( this.keyedBread.r )
				: true;
		},

		canEdit() {
			return this.keyedBread.hasOwnProperty( "e" )
				? this.$can( this.keyedBread.e )
				: true;
		},

		canAdd() {
			return this.keyedBread.hasOwnProperty( "a" )
				? this.$can( this.keyedBread.a )
				: true;
		},

		canDelete() {
			return this.keyedBread.hasOwnProperty( "d" )
				? this.$can( this.keyedBread.d )
				: true;
		}
	},

	created() {
		if ( !this.hasOwnProperty( "crud" ) ) {
			consoleWarn( "The 'crud' property must be declared", this );
		}
	}
};
